<template><div><h1>VUX V2.1.1Rc.10 released</h1>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] Add more less variables. #896</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[feature] Add event on-focus</li>
</ul>
<h2><a href="/en/components/timeline.html">Timeline</a></h2>
<ul><li>[fix] Fix icon position</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[fix] Fix warn icon style</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul><li>[feature] Add default disabled bg color. #896</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[feature] Support reset method #947 @erguotou520</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.10 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.10-85.vue?6a8cf522